import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import Icon from '../../../atoms/Icon'

const useStyles = makeStyles(() => ({
  chip: {
    position: 'relative',
    width: '100%',
    border: 'var(--border-neutral-thin)',
    borderRadius: 'var(--border-radius-sm)',
    marginBottom: '8px',
    display: 'flex',
    outline: ({ document }) => document.status?.uploaded ? '1px solid var(--color-success-500)' : '1px solid transparent',
    '& .__chip-content': {
      flex: '1 0'
    },
    '& .__chip-button:hover': {
      cursor: 'pointer'
    },
    '& .__chip-progress': {
      zIndex: 0,
      position: 'absolute',
      height: '100%',
      width: ({ document }) => document.status?.progress > 0 ? `${document.status.progress}%` : '0%',
      background: ({ document }) => document.status?.uploaded
        ? 'var(--color-success-050)'
        : 'linear-gradient(to right, color-mix(in srgb, var(--color-primary-300) 30%, transparent), var(--color-primary-300))',
      transition: 'width .3s ease-in, background .5s ease-in-out, outline 1s ease-in-out'
    },
    '& .__chip-wrapper': {
      width: '100%',
      zIndex: 1,
      padding: '5px 10px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '8px'
    }
  }
}))

function DocumentChip ({ document, onDelete }) {
  const classes = useStyles({ document })
  return (
    <div className={classes.chip}>
      <div className='__chip-progress' />
      <div className='__chip-wrapper'>
        <Icon name='document' />
        <span className='__chip-content'>{document.name}</span>
        <div className='__chip-button' role='button' onClick={onDelete}>
          <Icon name='delete' />
        </div>
      </div>
    </div>
  )
}

DocumentChip.propTypes = {
  document: PropTypes.shape({
    name: PropTypes.string
  }),
  onDelete: PropTypes.func
}

export default DocumentChip
